import styled from 'styled-components';

export const ContainerPerfil = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  color: #fff;
  margin-left: 30px;

  label {
    text-align: left;
    margin-left: 7px;
    font: normal normal normal 16px/20px Source Sans Pro;
  }

  .arrow-icon {
    width: 20px;
    margin-top: 1px;
  }
`;

export const DropMenuPerfil = styled.div`
  width: calc(195px - 32px);
  height: auto;

  display: ${(props) => (props.open ? 'flex' : 'none')};
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  padding: 16px;
  box-shadow: 0px 3px 30px #00000029;
  background-color: var(--color-white);

  position: absolute;
  top: 65px;
  right: 35px;
`;
